import { TasksKanbanStage } from '@brighterly/lib-core-types/tasks-kanban/enums'

export const TASKS_KANBAN_STAGE_LABEL: Record<TasksKanbanStage, string> = {
  [TasksKanbanStage.Backlog]: 'Backlog',
  [TasksKanbanStage.Todo]: 'To Do',
  [TasksKanbanStage.InProgress]: 'In Progress',
  [TasksKanbanStage.Waiting]: 'Waiting',
  [TasksKanbanStage.Resolved]: 'Resolved',
  [TasksKanbanStage.Cancelled]: 'Cancelled',
}
